import { VisuallyHidden } from '@zoopla/shared/components';
import { styled } from '@zoopla-eng/zds-components/themes';

const StyledIndicator = styled('span', {
    backgroundColor: '$graphicBuyingDark',
    borderRadius: '$circle',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '$S100',
    height: '$S100',
    variants: {
        type: {
            navVariant: {
                backgroundColor: '$graphicBuyingDefault',
                width: '$S400',
                height: '$S400'
            }
        }
    }
});

const StyledNotificationCount = styled('span', {
    fontSize: '$spoonSmall'
});

type Variants = React.ComponentProps<typeof StyledIndicator>['type'];

interface Props {
    count?: string;
    type?: Variants;
}

export const UpdateIndicator = ({ count, type }: Props) => {
    return (
        <StyledIndicator
            data-testid="header-notifications-new"
            type={type}
            className={`update-indicator update-indicator-${type}`}
        >
            {count ? (
                <StyledNotificationCount aria-hidden>
                    {count}
                </StyledNotificationCount>
            ) : null}
            <VisuallyHidden>You have {count} new updates</VisuallyHidden>
        </StyledIndicator>
    );
};
